import React from 'react';
import './App.css';
import Container from './pages/Container';

function App() {
  return (
    <div className="App">
      <Container/>
    </div>
  );
}

export default App;